import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Select,
    Button,
    Autocomplete,
    TextField
} from "@mui/material";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import SaveAs from '@mui/icons-material/SaveAs';
import { Form } from 'reactstrap';
import { useSelector } from "react-redux";
import './PaymentSummary.css';
import moment from 'moment';
import { sortByString } from '../../utils/sortByString';
import { formatMoney, formatCurrencyDisplay } from '../../utils/moneyFormat';
import { mapCompanyToBotmarkInfo } from '../../utils/botmarkCompanyInfo';
import { useCompanyMessages } from '../../hooks/useMessages';
import { useCompanyPrices } from '../../hooks/usePrices';
import { useCreateInvoice, useReferenceEstimates } from '../../hooks/useInvoices';
import { useBotmarkCompanyInfo } from '../../hooks/useCompanies';
import { EMPTY_GUID, NA_FILE_OPTION, fileAutocompleteOptions, isFileOptionEqual } from '../../query/queryConfig';

function EstimateForm ({item,handleCloseEstimate,jobName, selectedCustomer, dispatchSettings, invoiceNum}){
    const userCompany = useSelector((state) => state.CompanyReducer.userCompanies);
    const companyId = userCompany[0]?.id;
    const { data: CompanyPrices = [] } = useCompanyPrices({
        companyId,
        enabled: Boolean(companyId),
    });
    const { data: botmarkCompany } = useBotmarkCompanyInfo();
    const botmarkInfo = mapCompanyToBotmarkInfo(botmarkCompany);
    const [invoiceOptions, setInvoiceOptions] = React.useState([]);
    const [invoiceTaxOptions, setInvoiceTaxOptions] = React.useState([]);
    const [invoiceTaxTotals, setInvoiceTaxTotals] = React.useState([]);
    const [totalInvoiceSum, setTotalInvoiceSum] = React.useState(0);
    const [invoiceAfterTaxSum, setInvoiceAfterTaxSum] = React.useState(0);
    const [pointTypeTotal, setPointTypeTotal] = React.useState(0);
    const [currentStatus, setCurrentStatus] = React.useState(item?.isInvoiceAccepted);
    const [terms, setTerms] = React.useState('');

    const [customItemName, setCustomItemName] = React.useState(null);
    const [customDescription, setCustomDescription] = React.useState(null);
    const [quantity, setQuantity] = React.useState(null);
    const [customUnit, setCustomUnit] = React.useState(null);
    const [customRate, setCustomRate] = React.useState(null);
    const [updateR, setUpdateR] = React.useState();
    const [updateRStatus, setUpdateRStatus] = React.useState(false);

    const [customTotal, setCustomTotal] = React.useState(null);

    const [randomNumber, setRandomNumber] = React.useState();

    const [creditAdjustment, setCreditAdjustment] = React.useState();

    const createInvoice = useCreateInvoice();
    const { data: allCompanyMessages = [] } = useCompanyMessages({
        companyId,
        enabled: Boolean(companyId),
    });

    let totalInvoice = 0;
    let taxTotal = 0;
    let finalTotal = 0;

    /// This sets the dropdown to select a customer for a plan in invoicing ///
    const allCustomers = allCompanyMessages;

    const customers = [];
    allCustomers?.forEach(customerPusher);

    function customerPusher(allCustomers) {
        if (allCustomers.requestStatus === 1 || allCustomers.requestStatus === 2) {
        customers.push({
            id: allCustomers.id,
            companyId: allCustomers.companyId,
            created: allCustomers.created,
            deleted: allCustomers.deleted,
            message: allCustomers.message,
            requestStatus: allCustomers.requestStatus,
            userId: allCustomers.userId,
            userEmail: allCustomers.userEmail,
            customerName: allCustomers.customerName,
            userCompany: allCustomers.companyContact,
            companyStatus: allCustomers.companyStatus,
            userCompanyId: allCustomers.userCompanyId
        })}
    };

    /// For File name selection in invoice ///
    function getLastItem(thePath) {
        if (thePath == null || thePath == "") return "";
        var index = thePath.lastIndexOf('/') + 1;
        return thePath.substring(index);
    };

    /// This is for selection of price options to add to an invoice ///
    const handleInvoiceChange = (event) => {
        /// event is recognized as an array. use the index of this array to grab data keys for logic statement checks ///
        if (event == 'null') {

        } else if (event == 'custom') {
            setInvoiceOptions([...invoiceOptions, {custom: true, itemName: '', description: '', unit: '', rate: 0, quantity: 0, total: 0}]);
        } else if (event[2] == 'f') {
            setInvoiceOptions([...invoiceOptions, { ...CompanyPrices[event[0]], quantity: 0, total: 0 }]);
        } else if (event[2] == 't') {
            setInvoiceTaxOptions([...invoiceTaxOptions, { ...CompanyPrices[event[0]], total: formatMoney(CompanyPrices[event[0]].rate * totalInvoiceSum)}]);
        }
        recalculateTotals();
    };

    function addReferencePlan(event){
        let itemData = {};
        let pointData;
        itemData = JSON?.parse(event?.invoiceValues);
        if(event.pointList != ""){
            pointData = JSON?.parse(event?.pointList)
        }

        let thousandPoints = [];
        let thousandPoint = 0;
        let BMPoints = [];
        let BMTotal = 0;
        let EPoint = 0;
        let CPoint = 0;
        let UPoint = 0;
        let CLPoints = [];
        let CLTotal = 0;
        let AllPointTotal = 0;

        for (let i = 0; i < pointData?.length; i++) {
            if (pointData[i]?.TypeEnum == 0){
                thousandPoints.push(pointData[i]);
                thousandPoint = pointData[i]?.Quantity;
            }
            else if (pointData[i]?.TypeEnum == 1){
                EPoint = pointData[i]?.Quantity;
            }
            else if (pointData[i]?.TypeEnum == 2){
                CPoint = pointData[i]?.Quantity;
            }
            else if (pointData[i]?.TypeEnum == 3){
                UPoint = pointData[i]?.Quantity;
            }
            else if ([1, 2, 3].includes(pointData[i].TypeEnum)){
                BMPoints.push(pointData[i])
                BMTotal += pointData[i]?.Quantity;
            }
            else if ((![0, 1, 2, 3].includes(pointData[i].TypeEnum)) && pointData[i]?.Enabled == true){
                CLPoints.push(pointData[i])
                CLTotal += pointData[i]?.Quantity;
            }
            if (pointData[i]?.Enabled == true){
                AllPointTotal += pointData[i]?.Quantity;
            }
        }

        if(event != null){
            if(CLTotal != 0){
                setInvoiceOptions([...invoiceOptions, {
                    itemName: `${event.fileName}`,
                    description: `#${itemData.estimateNumber} | ${itemData.date} \npoints total: ${AllPointTotal} \n1000:${thousandPoint},E:${EPoint},C:${CPoint},U:${UPoint} CL: ${CLTotal}` ,
                    unit: 'Job',
                    rate: itemData.finalTotal,
                    quantity: 1,
                    total: itemData.finalTotal
                }]);
            } else {
                setInvoiceOptions([...invoiceOptions, {
                    itemName: `${event.fileName}`,
                    description: `#${itemData.estimateNumber} | ${itemData.date} \npoints total: ${AllPointTotal} \n1000:${thousandPoint},E:${EPoint},C:${CPoint},U:${UPoint}` ,
                    unit: 'Job',
                    rate: itemData.finalTotal,
                    quantity: 1,
                    total: itemData.finalTotal
                }]);
            }
        }

        // {itemName: "Credit", description: `${selectedFile.fileName}, # ${referenceData.estimateNumber}, ${referenceData.date}: ${creditReason}`, unit: 'special', rate: -planCredit, quantity: 1, total: -planCredit}
    }

    /// Rerun math calculation on the estimate page ///
    function recalculateTotals() {
        taxTotal = 0;
        totalInvoice = 0;
        finalTotal = 0;

        invoiceOptions?.map((option) => totalInvoice += option.rate * option.quantity);

        for (let i = 0; i < invoiceTaxOptions?.length; i++){
            invoiceTaxOptions[i].total = invoiceTaxOptions[i].rate * totalInvoice;
        };

        invoiceTaxOptions?.map((x) => taxTotal += Number(x?.total));

        finalTotal = taxTotal + totalInvoice;

        setTotalInvoiceSum(formatMoney(totalInvoice));
        setInvoiceAfterTaxSum(formatMoney(finalTotal));
    };

    const removePriceRow = (event) => {
        let tmp = [...invoiceOptions].toSpliced(event,1);

        setInvoiceOptions(tmp);

        setCustomDescription(null);
        setCustomItemName(null);
        setQuantity(null);
        setCustomUnit(null);
        setCustomRate(null);
        setUpdateR();
        setUpdateRStatus(false);

        setCustomTotal(null);

        recalculateTotals();
        setRandomNumber(Math.random());
    };

    const removeTaxRow = (event) => {
        let tmpTaxOptions = [...invoiceTaxOptions].toSpliced(event,1);
        let tmpTaxTotals = [...invoiceTaxTotals].toSpliced(event,1);

        setInvoiceTaxOptions(tmpTaxOptions);
        setInvoiceTaxTotals(tmpTaxTotals);
        setUpdateR();
        setUpdateRStatus(false);
        recalculateTotals();
        setRandomNumber(Math.random());
    };

    //// for tracking entered quantites ////
    function updateQuantityArray(item) {
        let tmp = [...invoiceOptions];

        if(quantity != null && customRate != null && customTotal != null){
            tmp[updateR].quantity = Number(quantity);
            tmp[updateR].rate = Number(customRate);
            tmp[updateR].total = Number(customTotal);
            if(quantity*customRate == customTotal){
                setInvoiceOptions(tmp);
            } else {
                swal({
                    title: `You have entered a custom quantity, rate, and total that do not add up. If you enter only 2 of 3 fields it will do the math for you.`,
                    position: 'center'
                });
            }
        } else if(quantity != null && customRate == null && customTotal == null){
            tmp[updateR].quantity = Number(quantity);
            tmp[updateR].rate = Number(item.rate);
            tmp[updateR].total = Number(item.rate)*Number(quantity);
            setInvoiceOptions(tmp);
        } else if(quantity == null && customRate != null && customTotal == null){
            tmp[updateR].quantity = item.quantity;
            tmp[updateR].rate = Number(customRate);
            tmp[updateR].total = Number(customRate)*Number(item.quantity);
            setInvoiceOptions(tmp);
        } else if(quantity != null && customRate != null && customTotal == null){
            tmp[updateR].rate = Number(customRate);
            tmp[updateR].quantity = Number(quantity);
            tmp[updateR].total = Number(customRate)*Number(quantity);
            setInvoiceOptions(tmp);
        } else if(quantity != null && customRate == null && customTotal != null){
            tmp[updateR].rate = Number(customTotal)/Number(quantity);
            tmp[updateR].quantity = Number(quantity);
            tmp[updateR].total = Number(customTotal);
            setInvoiceOptions(tmp);
        } else if(quantity == null && customRate == null && customTotal != null){
            tmp[updateR].rate = Number(customTotal)/Number(item.quantity);
            tmp[updateR].quantity = Number(item.quantity);
            tmp[updateR].total = Number(customTotal);
            setInvoiceOptions(tmp);
        } else {
            tmp[updateR].rate = Number(item.rate);
            tmp[updateR].quantity = item.quantity;
            tmp[updateR].total = Number(item.rate)*Number(item.quantity);
            setInvoiceOptions(tmp);
        }

        setQuantity(null);
        setCustomRate(null);
        setCustomTotal(null);
    };
    function updateCustomItemName(item) {
        let tmp = [...invoiceOptions];

        if(customItemName != null){
            tmp[updateR].itemName = customItemName;
            setInvoiceOptions(tmp);
        } else {
            tmp[updateR].itemName = item.itemName;
            setInvoiceOptions(tmp);
        }

        setCustomItemName(null);
    };
    function updateCustomDescription(item) {
        let tmp = [...invoiceOptions];

        if(customDescription != null){
            tmp[updateR].description = customDescription;
            setInvoiceOptions(tmp);
        } else {
            tmp[updateR].description = item.description;
            setInvoiceOptions(tmp);
        }

        setCustomDescription(null);
    };
    function updateCustomUnit(item) {
        let tmp = [...invoiceOptions];

        if(customUnit != null){
            tmp[updateR].unit = customUnit;
            setInvoiceOptions(tmp);
        } else {
            tmp[updateR].unit = item.unit;
            setInvoiceOptions(tmp);
        }

        setCustomUnit();
    };

    function clearInputs(){
        setCustomItemName();
        setCustomDescription();
        setQuantity(0);
        setCustomUnit();
        setCustomRate(0);
    }

    function CheckUpdate(item){
        updateCustomItemName(item);
        updateCustomDescription(item);
        updateCustomUnit(item);
        updateQuantityArray(item);
        setUpdateR();
        setUpdateRStatus(false);
    }

    function UpdateRow(item){
        setCustomDescription(item);
        setCustomItemName(item);
        setCustomRate(item);
        setCustomUnit(item);
        setQuantity(item);
        setCustomTotal(item);

        CheckUpdate(item);
        setUpdateR();
        setUpdateRStatus(false);
        document.getElementById("nameInput").value = "";
        document.getElementById("descriptionInput").value = "";
        document.getElementById("quantityInput").value = "";
        document.getElementById("unitInput").value = "";
        document.getElementById("rateInput").value = "";
        document.getElementById("totalInput").value = "";
    };

    function CancelUpdateRow(){
        setUpdateR();
        setUpdateRStatus(false);
        document.getElementById("nameInput").value = "";
        document.getElementById("descriptionInput").value = "";
        document.getElementById("quantityInput").value = "";
        document.getElementById("unitInput").value = "";
        document.getElementById("rateInput").value = "";
        document.getElementById("totalInput").value = "";
    }

    function produceInvoiceData() {
        let invoiceData = {
            date: moment().format("MM/DD/YYYY"),
            estimateNumber: invoiceNum,
            terms: terms,
            items: [],
            taxes: [],
            creditAdjustment: creditAdjustment,
            finalTotal: invoiceAfterTaxSum,
            pointTypeTotal: pointTypeTotal,
            customerInfo: selectedCustomer,
            processorInfo: userCompany[0],
            botmarkInfo: botmarkInfo
        };

        for (let i = 0; i < invoiceOptions?.length; i++){
            invoiceData.items.push({
                companyId: invoiceOptions[i].companyId,
                itemName: invoiceOptions[i].itemName,
                description: invoiceOptions[i].description,
                unit: invoiceOptions[i].unit,
                isForTaxes: invoiceOptions[i].isForTaxes,
                isBotmarkPrimary: invoiceOptions[i].isBotmarkPrimary,
                id: invoiceOptions[i].id,
                rate: invoiceOptions[i].rate,
                created: invoiceOptions[i].created,
                updated: invoiceOptions[i].updated,
                deleted: invoiceOptions[i].deleted,
                quantity: invoiceOptions[i]?.quantity,
                total: invoiceOptions[i]?.rate * invoiceOptions[i]?.quantity
            })
        };

        for (let i = 0; i < invoiceTaxOptions?.length; i++){
            invoiceData.taxes.push({
                companyId: invoiceTaxOptions[i].companyId,
                itemName: invoiceTaxOptions[i].itemName,
                description: invoiceTaxOptions[i].description,
                unit: invoiceTaxOptions[i].unit,
                isForTaxes: invoiceTaxOptions[i].isForTaxes,
                isBotmarkPrimary: invoiceTaxOptions[i].isBotmarkPrimary,
                id: invoiceTaxOptions[i].id,
                rate: invoiceTaxOptions[i].rate,
                created: invoiceTaxOptions[i].created,
                updated: invoiceTaxOptions[i].updated,
                deleted: invoiceTaxOptions[i].deleted,
                quantity: null,
                total: formatMoney(totalInvoiceSum * invoiceTaxOptions[i].rate)
            })
        };

        return invoiceData;
    };

    function SaveInvoice(){
        let invoiceData = produceInvoiceData();

        let saveInvoiceObject = {
            CustomerId: selectedCustomer?.userCompanyId,
            DeveloperId: userCompany[0].id,
            InvoiceValues: JSON.stringify(invoiceData),
            OpenInvoice: true,
            isSent: false,
            isInvoiceAccepted: parseInt(1),
            invoiceJobName: jobName,
            customerInvoiceStatus: parseInt(0),
            id: item?.id
        };
        if(jobName == ""){
            swal({
                title: "Missing Job Name",
                text: `Please Enter a Job Name.`,
                icon: "warning",
                position: 'center'
            })
        } else if (selectedCustomer.userCompanyId != EMPTY_GUID){
            swal({
                title: "SAVE ESTIMATE",
                text: `Save estimate for later completion. Please double check before saving estimate for ${selectedCustomer?.companyContact}.`,
                icon: "warning",
                buttons: true,
                dangerMode: false,
            })
            .then((willUpdate) => {
                if (willUpdate) {
                    createInvoice.mutate({ invoiceObject: saveInvoiceObject });
                    handleCloseEstimate();
            } else {
                swal({
                    title: `Estimate Not Sent.`,
                    position: 'center'
                });
            }})
        } else {
            swal({
                title: `No Customer Found, Please Select Customer.`,
                position: 'center'
            });
        }
    };

    function SubmitInvoice(){

        let invoiceData = produceInvoiceData();

        let sendInvoiceObject = {
            CustomerId: selectedCustomer?.userCompanyId,
            DeveloperId: userCompany[0].id,
            InvoiceValues: JSON.stringify(invoiceData),
            OpenInvoice: true,
            isSent: true,
            isInvoiceAccepted: parseInt(1),
            invoiceJobName: jobName,
            customerInvoiceStatus: parseInt(1),
            id: item?.id
        };
        if(jobName == ""){
            swal({
                title: "Missing Job Name",
                text: `Please Enter a Job Name.`,
                icon: "warning",
                position: 'center'
            })
        } else if (selectedCustomer.userCompanyId != EMPTY_GUID){
            swal({
                title: "SUBMIT ESTIMATE",
                text: `Please double check before sending estimate to ${selectedCustomer?.companyContact}.`,
                icon: "warning",
                buttons: true,
                dangerMode: false,
            })
            .then((willUpdate) => {
                if (willUpdate) {
                    createInvoice.mutate({ invoiceObject: sendInvoiceObject });
                    handleCloseEstimate();
            } else {
                swal({
                    title: `Estimate Not Sent.`,
                    position: 'center'
                });
            }})
        } else {
            swal({
                title: `No Customer Found, Please Select Customer.`,
                position: 'center'
            });
        }
    };

    let data;

    function initializeInvoice() {
        if(item != null){
            data = JSON.parse(item?.invoiceValues);

            setInvoiceOptions(data?.items);
            setInvoiceTaxOptions(data?.taxes);
            setTerms(data?.terms);
            setCreditAdjustment(data?.creditAdjustment)

            invoiceTaxOptions.map((taxOption) => taxTotal += taxOption.total);
        }
    };

    /// This sets the dropdown to select a customer for a plan in invoicing ///
    const referenceCustomerId = selectedCustomer?.userCompanyId !== EMPTY_GUID
        ? selectedCustomer.userCompanyId
        : companyId;
    const { data: CompanyInvoices = [] } = useReferenceEstimates({
        companyId,
        customerId: referenceCustomerId,
        enabled: Boolean(companyId && referenceCustomerId),
    });

    const [ selectedFile, setSelectedFile] = React.useState(NA_FILE_OPTION);

    let allFilesArray = sortByString(CompanyInvoices ?? [], 'fileName');

    const defaultProps = {
        options: fileAutocompleteOptions(allFilesArray),
        getOptionLabel: (option) => option?.fileName ?? '',
        isOptionEqualToValue: isFileOptionEqual,
        renderOption: (props, option) => (
            <li {...props} key={option.fileId}>
                {option.fileName}
            </li>
        ),
    };

    function FocusRow(item){
        setCustomItemName(item?.itemName)
        setCustomDescription(item?.description)
        setQuantity(item?.quantity)
        setCustomUnit(item?.unit)
        setCustomRate(item?.rate)
    };

    React.useEffect(() => {
        if(item != null){
            initializeInvoice();
        }
    },[]);

    React.useEffect(() => {
        recalculateTotals();
    },[invoiceOptions,invoiceTaxOptions,totalInvoiceSum,invoiceAfterTaxSum]);

    return(
        <div>
            <Form>
                <Table>
                    <TableHead>
                        <TableCell className="estimateTableCellVariant" style={{textAlign:"center"}}>
                        {updateRStatus == true ?
                            <SaveAs color="warning"/>
                            :
                            <CheckBoxIcon color="success"/>
                        }
                        </TableCell>
                        <TableCell className="estimateTableCellVariant">Item</TableCell>
                        <TableCell className="estimateTableCellVariant">Description</TableCell>
                        <TableCell className="estimateTableCellVariant">Qty</TableCell>
                        <TableCell className="estimateTableCellVariant">U/M</TableCell>
                        <TableCell className="estimateTableCellVariant">Rate</TableCell>
                        <TableCell className="estimateTableCellVariant">Amount</TableCell>
                        <TableCell className="estimateTableCellVariant"></TableCell>
                    </TableHead>
                    <TableBody key={randomNumber}>
                        {invoiceOptions?.map((item, i) => (
                             updateR == i || updateR == null ?
                                <TableRow>
                                    {updateRStatus == true ?
                                        <TableCell className="estimateTableCellVariant">
                                            <Button value={i} onClick={()=>UpdateRow(item)}>Update Row</Button>
                                        </TableCell>
                                    :
                                        <TableCell className="estimateTableCellVariant">
                                            <Button disabled value={i} >Update Row</Button>
                                        </TableCell>
                                    }
                                    <TableCell className="estimateTableCellVariant"><TextField id="nameInput" style={{ minWidth:'250px'}} placeholder={item?.itemName} onChange={(event)=> {setCustomItemName(event.target.value), setUpdateR(i), setUpdateRStatus(true)}}/></TableCell>
                                    <TableCell className="estimateTableCellVariant"><TextField multiline style={{ minWidth:'250px'}} id="descriptionInput" placeholder={item?.description} onChange={(event)=> {setCustomDescription(event.target.value), setUpdateR(i), setUpdateRStatus(true)}}/></TableCell>
                                    <TableCell className="estimateTableCellVariant"><TextField id="quantityInput" placeholder={item?.quantity} onChange={(event)=> {setQuantity(Number(event.target.value)), setUpdateR(i), setUpdateRStatus(true)}}/></TableCell>
                                    <TableCell className="estimateTableCellVariant"><TextField id="unitInput" placeholder={item?.unit} onChange={(event)=> {setCustomUnit(event.target.value), setUpdateR(i), setUpdateRStatus(true)}}/></TableCell>
                                    <TableCell className="estimateTableCellVariant"><TextField id="rateInput" placeholder={item?.rate} onChange={(event)=> {setCustomRate(Number(event.target.value)), setUpdateR(i), setUpdateRStatus(true)}}/></TableCell>
                                    <TableCell className="estimateTableCellVariant"><div style={{display:'flex', flexDirection:'row'}}><span style={{margin:'auto', fontSize:'large'}}>$</span><TextField id="totalInput" placeholder={formatMoney(item?.total)} onChange={(event)=> {setCustomTotal(Number(event.target.value)), setUpdateR(i), setUpdateRStatus(true)}}></TextField></div></TableCell>

                                    {updateRStatus == true ?
                                        <TableCell className="estimateTableCellVariant"><Button color="error" value={i} onClick={(event)=> {CancelUpdateRow()}}>Cancel</Button></TableCell>
                                        :
                                        <TableCell className="estimateTableCellVariant"><Button color="error" value={i} onClick={(event)=> removePriceRow(event.target.value)}>Remove</Button></TableCell>
                                    }

                                </TableRow>
                            :
                                <TableRow>
                                    <TableCell className="estimateTableCellVariant"> <Button value={i} disabled >Update Row</Button></TableCell>
                                    <TableCell className="estimateTableCellVariant"><TextField disabled style={{ minWidth:'250px'}} placeholder={item?.itemName} onChange={(event)=> {setCustomItemName(event.target.value)}}/></TableCell>
                                    <TableCell className="estimateTableCellVariant"><TextField multiline style={{ minWidth:'250px'}} disabled placeholder={item?.description} onChange={(event)=> {setCustomDescription(event.target.value)}}/></TableCell>
                                    <TableCell className="estimateTableCellVariant"><TextField disabled placeholder={item?.quantity} onChange={(event)=> {setQuantity(event.target.value)}}/></TableCell>
                                    <TableCell className="estimateTableCellVariant"><TextField disabled placeholder={item?.unit} onChange={(event)=> {setCustomUnit(event.target.value)}}/></TableCell>
                                    <TableCell className="estimateTableCellVariant"><TextField disabled placeholder={item?.rate} onChange={(event)=> {setCustomRate(event.target.value)}}/></TableCell>
                                    <TableCell className="estimateTableCellVariant"><div style={{display:'flex', flexDirection:'row'}}><span style={{margin:'auto', fontSize:'large'}}>$</span><TextField disabled placeholder={formatMoney(item?.total)} onChange={(event)=> {setCustomTotal(Number(event.target.value)), setUpdateR(i), setUpdateRStatus(true)}}></TextField></div></TableCell>
                                    <TableCell className="estimateTableCellVariant"><Button disabled color="error" value={i} onClick={(event)=> removePriceRow(event.target.value)}>Remove</Button></TableCell>
                                </TableRow>
                        ))}
                        <TableRow>
                            <TableCell>
                                <br/>
                                <label>Add Row:</label>
                                <form>
                                    <Select
                                        native
                                        onChange={(event)=> handleInvoiceChange(event.target.value)}
                                    >
                                        <option aria-label="None" value='null' />
                                        <option value='custom'>Custom</option>
                                        {CompanyPrices?.map((item, i) => (
                                            <option
                                                value={[i, item.isForTaxes]}
                                            >
                                                {item.itemName}
                                            </option>
                                        ))}
                                    </Select>
                                </form>
                                <br/>
                            </TableCell>
                            <TableCell></TableCell>
                            <TableCell>
                                <br/>
                                <form>
                                    <label>Add Reference Job:</label>
                                    <Autocomplete
                                        disablePortal
                                        value={selectedFile}
                                        {...defaultProps}
                                        renderInput={(params) =>
                                            <TextField
                                            {...params}
                                            />}
                                        onChange={(event,newValue) => {
                                            if(newValue == null){setSelectedFile(NA_FILE_OPTION)}else{addReferencePlan(newValue)}
                                        }}
                                    />
                                </form>
                                <br/>
                            </TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell>{userCompany[0].name} Estimate Sub-Total</TableCell>
                            <TableCell>{formatCurrencyDisplay(totalInvoiceSum)}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        {invoiceTaxOptions?.map((item, i) => (
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>{item.itemName}</TableCell>
                                <TableCell>{item.description}</TableCell>
                                <TableCell></TableCell>
                                <TableCell>{item.unit}</TableCell>
                                <TableCell>{item.rate}</TableCell>
                                <TableCell>{formatCurrencyDisplay(item.total)}</TableCell>
                                <TableCell><Button color="error" value={i} onClick={(event)=> removeTaxRow(event.target.value)}>Remove</Button></TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell><b>Total</b></TableCell>
                            <TableCell>{formatCurrencyDisplay(invoiceAfterTaxSum)}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Form>
            <Button onClick={()=>recalculateTotals()}>Recalculate</Button>
            <br/>
            { (item?.isSent == false  || item == null) &&
                <Button onClick={()=>SaveInvoice()}>Save Progress</Button>
            }
            <br/>
            <Button onClick={()=>SubmitInvoice()}>Send To Customer</Button>
        </div>
    )
}

export default EstimateForm;